// Module
var code = "<div class=\"visible-selected condensed remove-top-padding clearfix col-xs-12 has-select\" ng-show=\"row.std_desc\" ng-bind=\"row.std_desc\"></div>\n";
// Exports
module.exports = code;